import TokenCard from "../views/card/tokenCard";
import NoPresentCard from "../views/card/noPresentCard";
import CardPaymentLink from "../views/card/cardPaymentLink";

import BinaryIcon from "../assets/icons/binary.svg";
import BinaryHoverIcon from "../assets/icons/binaryHover.svg";
import NoPresentCardIcon from "../assets/icons/card-no-present.svg";
import NoPresentCardHover from "../assets/icons/card-no-presentHover.svg";
import PaperClip from "../assets/icons/link.svg";
import PaperClipHover from "../assets/icons/linkHover.svg";

const routesCard = [
    {
        id: "cm3a1",
        path: "/token-card",
        name: "Tokenizar Cartão",
        icon: BinaryIcon,
        iconHover: BinaryHoverIcon,
        layout: "/card",
        component: TokenCard,
        redirect: false,
    },

    {
        id: "cm3a2",
        path: "/no-present-card",
        name: "Cartão Não Presente",
        icon: NoPresentCardIcon,
        iconHover: NoPresentCardHover,
        layout: "/card",
        component: NoPresentCard,
        redirect: false,
    },

    {
        id: "cm3a3",
        path: "/payment-link",
        name: "Link de Pagamento",
        icon: PaperClip,
        iconHover: PaperClipHover,
        layout: "/card",
        component: CardPaymentLink,
        redirect: false,
    },
]

export default routesCard;